import { ColumnFilter } from "./ColumnFilter";

export const COLUMNS = [
    {
        Header: "Ονομασία",
        accessor: "Ονομασία",
        Filter: false
    },
    {
        Header: "Τηλέφωνο",
        accessor: "Τηλέφωνο",
        Filter: false
    },
    {
        Header: "Διεύθυνση",
        accessor: "Διεύθυνση",
        Filter: false
    },
    {
        Header: "Πόλη",
        accessor: "Πόλη",
        Filter: ColumnFilter
    },
    {
        Header: "Δημος",
        accessor: "Δημος",
        Filter: false
    },

]